
    import * as React from 'react';

    const ArrowDownFilled20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" fill="none" style={svgStyle}><path d="M6.20711 8L13.7929 8L10 11.7929L6.20711 8Z" stroke="#191A1B" /></svg>
        </div>
      );
    };

    ArrowDownFilled20.displayName = 'ArrowDownFilled20';

    export default ArrowDownFilled20;
  